import { parseFieldsArrayToObject } from '@interlayer/js/app/components/main/Registration/utils/parseFieldsArrayToObject';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

import { TRetailPinFields } from './types';

export const RETAIL_PIN_FIELDS: TRetailPinFields[] = [
    VALIDATION_FIELDS.pinReg,
    VALIDATION_FIELDS.confirmPinReg,
    VALIDATION_FIELDS.verificationQuestion,
    VALIDATION_FIELDS.verificationAnswer
];

export const RETAIL_PIN_DATA = parseFieldsArrayToObject(RETAIL_PIN_FIELDS);
